//@ts-nocheck
import { createContext } from 'react';
const RootNavigatorContext = createContext({});
export default RootNavigatorContext;